import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SplitType from 'split-type';
import mediaAccordion from '../../../blocks/media-accordion/scripts/media-accordion';

gsap.registerPlugin(ScrollTrigger);

export default function () {
  mediaAccordion();

  const wrapperPage = document.querySelector('[data-barba-namespace="about"]');

  if (wrapperPage) {
    const mm = gsap.matchMedia();
    const toggleViewBreakPoint = 576;

    let isPreloaderDone = false;
    document.addEventListener('preloaderDone', () => {
      isPreloaderDone = true;
    });

    mm.add({
      isMobile: `(max-width: ${toggleViewBreakPoint - 1}px)`,
      isDesktop: `(min-width: ${toggleViewBreakPoint}px)`,
    }, (context) => {
      const { isMobile } = context.conditions;
      let scrollHorizontalTween;

      const horizontalWrapper = wrapperPage.querySelector(isMobile ? '[data-projects-wrapper]' : '[data-horizontal-scroll]');
      const horizontalSections = wrapperPage.querySelectorAll(isMobile ? '[data-project]' : '[data-section]');
      if (horizontalWrapper && horizontalSections.length > 0) {
        let widthHorizontalScroll = 0;

        const getMaxWidth = () => {
          // eslint-disable-next-line max-len
          widthHorizontalScroll = horizontalWrapper.scrollWidth - document.documentElement.clientWidth;
        };
        getMaxWidth();
        ScrollTrigger.addEventListener('revert', getMaxWidth);

        scrollHorizontalTween = gsap.to(horizontalSections, {
          x: () => `-${widthHorizontalScroll}px`,
          ease: 'none',
          scrollTrigger: {
            trigger: horizontalWrapper,
            pin: true,
            scrub: 1,
            end: () => widthHorizontalScroll,
            invalidateOnRefresh: true,
          },
        });
      }

      const headers = document.querySelectorAll('[data-header]');
      if (headers.length) {
        const sections = gsap.utils.toArray('[data-header-color]');
        // eslint-disable-next-line max-len
        const isOwnProperty = (obj, property) => Object.prototype.hasOwnProperty.call(obj, property);

        const changeHeaderView = (section) => {
          if (isOwnProperty(section.dataset, 'headerColor')) {
            headers.forEach((header) => {
              // eslint-disable-next-line no-param-reassign
              header.className = `header header--${section.dataset.headerColor}`;
            });
          }
        };

        sections.forEach((section) => {
          ScrollTrigger.create({
            trigger: section,
            containerAnimation: isMobile ? null : scrollHorizontalTween,
            start: isMobile ? 'top top+=20px' : 'left left+=20px',
            end: isMobile ? 'bottom top+=20px' : 'right left+=20px',
            onEnter: () => changeHeaderView(section),
            onEnterBack: () => changeHeaderView(section),
          });
        });
      }

      const heroMedia = document.querySelector('[data-hero-media]');
      if (heroMedia) {
        const spitText = heroMedia.querySelector('[data-split-text]');

        if (spitText) {
          // eslint-disable-next-line no-new
          new SplitType(spitText);

          if (isPreloaderDone || sessionStorage.getItem('preloaderDone')) {
            gsap.to(spitText.querySelectorAll('.char'), {
              opacity: 1,
              y: 0,
              stagger: 0.05,
              delay: 0.2,
              duration: 0.1,
            });
          } else {
            gsap.set(spitText.querySelectorAll('.char'), { opacity: 0 });
            document.addEventListener('preloaderDone', () => {
              gsap.to(spitText.querySelectorAll('.char'), {
                opacity: 1,
                y: 0,
                stagger: 0.05,
                delay: 0.2,
                duration: 0.1,
              });
            });
          }
        }
      }

      const accordion = document.querySelector('[data-accordion]');
      if (accordion) {
        const images = accordion.querySelectorAll('.media-accordion__image');
        const title = accordion.querySelector('[data-accordion-title]');
        const tabs = accordion.querySelectorAll('[data-accordion-tabs]');

        gsap.set(tabs, { x: -5, y: -5, opacity: 0 });
        gsap.set(title, { x: -5, y: -5, opacity: 0 });
        gsap.set(images, {
          x: -5, y: -5, scaleX: 0.5, opacity: 0,
        });

        gsap.timeline({
          scrollTrigger: {
            trigger: accordion,
            containerAnimation: isMobile ? null : scrollHorizontalTween,
            start: isMobile ? 'top center' : 'left 75%',
          },
        })
          .to(images, {
            x: 0, y: 0, scaleX: 1, opacity: 1, ease: 'power.in', stagger: 0.11,
          }, '<')
          .to(title, {
            opacity: 1, x: 0, y: 0,
          })
          .to(tabs, {
            x: 0, y: 0, opacity: 1, stagger: 0.3,
          }, '>');
      }

      const quote = document.querySelector('[data-quote]');
      if (quote) {
        const spitText = quote.querySelector('[data-split-text]');
        const bottom = quote.querySelector('[data-contact-bottom]');

        // eslint-disable-next-line no-new
        if (spitText) new SplitType(spitText);

        // Create a timeline for the quote animation
        const quoteTimeline = gsap.timeline({
          scrollTrigger: {
            trigger: quote,
            containerAnimation: isMobile ? null : scrollHorizontalTween,
            start: isMobile ? 'top center' : 'left center',
          },
        });

        quoteTimeline.to(spitText.querySelectorAll('.char'), {
          y: 0,
          stagger: 0.01,
          delay: 0.1,
          duration: 0.1,
          onComplete: () => {
            gsap.fromTo(bottom, { opacity: 0, y: -15 }, { opacity: 1, y: 0 });
          },
        });
      }

      // horizontal image + text
      const horizontalImage = document.querySelector('[data-horizontal-image-text]');
      if (horizontalImage) {
        const horizontalImageSplitText = horizontalImage.querySelector('[data-horizontal-image-split-text]');
        const horizontalImageHeadline = horizontalImage.querySelector('[data-horizontal-image-headline]');
        const horizontalImageBottom = horizontalImage.querySelector('[data-horizontal-image-bottom]');

        // eslint-disable-next-line no-new
        if (horizontalImageSplitText) new SplitType(horizontalImageSplitText);

        gsap.timeline({
          scrollTrigger: {
            trigger: horizontalImage,
            containerAnimation: isMobile ? null : scrollHorizontalTween,
            start: isMobile ? 'top center' : 'left center',
          },
        })
          .to(horizontalImageSplitText.querySelectorAll('.char'), {
            y: 0,
            stagger: 0.01,
            delay: 0.1,
            duration: 0.1,
          })
          .fromTo(horizontalImageBottom, { opacity: 0, y: -15 }, { opacity: 1, y: 0 }, 0)
          .fromTo(horizontalImageHeadline, { opacity: 0, y: -15 }, { opacity: 1, y: 0 }, 0);
      }

      // team
      const members = document.querySelectorAll('[data-team-member]');
      members.forEach((member) => {
        const card = member.querySelector('[data-cards-media]');
        const texts = member.querySelectorAll('[data-team-split-text]');

        gsap.set(card, {
          scale: 1.1,
        });

        texts.forEach((text) => {
          // eslint-disable-next-line no-new
          new SplitType(text);

          gsap.timeline({
            scrollTrigger: {
              trigger: member,
              containerAnimation: isMobile ? null : scrollHorizontalTween,
              start: isMobile ? 'top center' - card.offsetWidth : 'left center' - card.offsetWidth,
            },
          })
            .to(text.querySelectorAll('.char'), {
              y: 0,
              stagger: 0.01,
              duration: 0.1,
            });
        });

        gsap.to(card, {
          duration: 1,
          delay: 0.5,
          scale: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: card,
            containerAnimation: isMobile ? null : scrollHorizontalTween,
            start: isMobile ? 'top center' : 'left center' - card.offsetWidth,
            end: 'center',
          },
        });
      });
    });
  }
}
